/* eslint react/prop-types: 0 */

import React, { useEffect, useState } from 'react';
import { Spin, Result } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import qs from 'qs';

const Confirm = (props) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    console.log('TOKEN:', props.token);
    if (!props.token) {
      setStatus('FAIL');
      return;
    }
    if (props.token) {
      axios({
        method: 'post',
        url: '/cgi-bin/',
        data: qs.stringify({
          confirmToken: props.token
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
      })
        .then(function () {
          setStatus('SUCCESS');
        })
        .catch(function () {
          setStatus('FAIL');
        });
    }
  }, [props.token]);
  if (status === 'SUCCESS') {
    return (
      <Result
        status="success"
        title="Email успешно подтвержден"
        subTitle="В ближайшее время с вами свяжется менеджер для уточнения деталей"
      />
    );
  }
  if (status === 'FAIL') {
    return <Result status="error" title="Неверная ссылка" />;
  }
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 44 }} spin />} />
    </div>
  );
};

export default Confirm;
